"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.meetingsUrl = void 0;
const env = require("./environment");
const generate_1 = require("./generate");
const types_1 = require("./types");
exports.meetingsUrl = process.env.MEETINGS_URL;
function endLoading() {
    document.body.removeAttribute('loading');
}
function ajaxSuccess() {
    const urlParams = new URLSearchParams(window.location.search);
    let meetingType = types_1.MEETING_TYPE.ALL;
    if (urlParams.has('meeting_type')) {
        meetingType = types_1.MEETING_TYPE[urlParams.get('meeting_type')];
    }
    const start = new Date().getTime();
    if (window.location.toString().includes('district')) {
        let district, subDistrict = null;
        if (urlParams.has('district')) {
            district = urlParams.get('district');
        }
        if (urlParams.has('subDistrict')) {
            subDistrict = urlParams.get('subDistrict');
        }
        if (!district && !subDistrict) {
            (0, generate_1.generateDistrictListPage)(JSON.parse(this.responseText));
        }
        else {
            (0, generate_1.generateDistrictWtf)(JSON.parse(this.responseText), district, subDistrict, urlParams.has('qrcode'), urlParams.has('hideDate'), urlParams.has('customTitle') ? urlParams.get('customTitle') : undefined, urlParams.has('postcodeAreaFilter') ? urlParams.get('postcodeAreaFilter').split(',') : []);
        }
    }
    else {
        (0, generate_1.generateFullWtf)(JSON.parse(this.responseText), meetingType);
    }
    const now = new Date().getTime();
    const minLoadTimeMs = 1500;
    if (now - start < minLoadTimeMs) {
        setTimeout(endLoading, minLoadTimeMs - (now - start));
    }
    else {
        endLoading();
    }
}
function fetchData() {
    const req = new XMLHttpRequest();
    req.open('GET', exports.meetingsUrl);
    req.onload = ajaxSuccess;
    req.send();
}
document.body.onload = () => {
    if (env.IS_IOS) {
        document.body.setAttribute('ios', '');
    }
    fetchData();
};
